import request from '@/utils/request';
export function getList(params) {
    return request({
        url: '/notice/getList',
        method: 'get',
        params,
    });
}
